const daysAgo = (days, date = new Date()) => {
  const d = new Date();
  
  d.setDate(date.getDate() - days);

  return d;
};

export default daysAgo;